/// <amd-module name="VSS/Platform/Components/ErrorBoundary" />
export * from "./ErrorBoundary/ErrorBoundary";
export { IErrorBoundaryProps } from "./ErrorBoundary/ErrorBoundary.Props";
